// extracted by mini-css-extract-plugin
export const android = "MobileAppBadge__android__nA7eU";
export const badge = "MobileAppBadge__badge__YGd2S";
export const ios = "MobileAppBadge__ios__D+Gv+";